import React from 'react';
import { Select } from '@avila-tek/ui/src';
import { Benefit } from '../../../models';

interface SelectBenefitProps {
  benefits: Benefit[];
  benefitSelected: string;
  setBenefitSelected: React.Dispatch<React.SetStateAction<string>>;
}

function SelectBenefit({
  benefits,
  benefitSelected,
  setBenefitSelected,
}: SelectBenefitProps) {
  return (
    <div className="flex flex-col md:flex-row items-center">
      <span className="mr-3 text-text-gray">
        Beneficio a otorgar por cumplimiento de metas:
      </span>
      <div className="w-72">
        <Select
          onChange={(e) => {
            setBenefitSelected(e.target.value);
          }}
          value={benefitSelected}
        >
          <option value="" disabled>
            Seleccione
          </option>
          {benefits?.map((benefit) => (
            <option key={benefit?._id} value={benefit?._id}>
              {benefit?.title}
            </option>
          ))}
        </Select>
      </div>
    </div>
  );
}

export default SelectBenefit;
